import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TaxCheckResponse } from '@/app/shared/interfaces/user.interface';
import { NotificationService } from '@/app/shared/services/notification.service';

@Component({
  selector: 'app-tax-check-modal',
  templateUrl: './tax-check-modal.component.html',
  styleUrls: ['./tax-check-modal.component.scss']
})
export class TaxCheckModalComponent {

  @Input() result: TaxCheckResponse | null = null;
  @Input() isChecking = false;

  parsedResults: any[] = [];
  private parsedRawResponse: string | undefined;

  constructor(
    public activeModal: NgbActiveModal,
    private notificationService: NotificationService
  ) {}

  async copyTaxCode(taxCode: string) {
    try {
      await navigator.clipboard.writeText(taxCode);
      this.notificationService.success('Đã sao chép mã số thuế');
    } catch {
      this.notificationService.error('Không thể sao chép mã số thuế. Vui lòng thử lại.');
    }
  }

  get results() {
    const rawResponse = this.result?.data?.rawResponse;
    if (rawResponse === this.parsedRawResponse) return this.parsedResults;

    this.parsedRawResponse = rawResponse;
    this.parsedResults = [];
    if (!rawResponse) return this.parsedResults;

    try {
      const raw = JSON.parse(rawResponse);
      const innerData = raw?.Data?.data;

      if (Array.isArray(innerData)) {
        this.parsedResults = innerData;
      } else if (innerData) {
        this.parsedResults = [innerData];
      }
    } catch (e) {
      console.error('Lỗi parse rawResponse:', e);
    }
    return this.parsedResults;
  }

  close() {
    this.activeModal.close();
  }

  fillBusinessName(selected: any) {
    if (selected?.companyName) {
      this.activeModal.close(selected.companyName);
    } else {
      this.activeModal.close();
    }
  }
}
